import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormHandles, GenericFormSection } from "models/propTypes/genericFormProps";
import { TimeReportingProjectFormViewProps } from "models/propTypes/timeReportingProjectPropTypes";
import { TimeReportingProjectFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants, TimeReportingProjectConstants } from "utils/constants";
//#endregion
//#region components
import { GenericForm } from "components/common";
import useGeneralInfoFields from "./useGeneralInfoFields";
import useMembersFields from "./useMembersFields";
import useInvoicingFields from "./useInvoicingFields";
import useProjectCategoryFields from "./useProjectCategoryFields";
//#endregion

const TimeReportingProjectForm: ForwardRefRenderFunction<FormHandles, TimeReportingProjectFormViewProps> = (
  props,
  ref
) => {
  const genericInfoFields = useGeneralInfoFields(props);
  const membersFields = useMembersFields(props);
  const invoicingFields = useInvoicingFields(props);
  const projectCategoryFields = useProjectCategoryFields(props);

  const formFieldsStep1: GenericFormSection<TimeReportingProjectFormTypes.Create>[] = [
    {
      label: TranslationKeys.TimeReportingProject.TimeReportingProjectInformation,
      type: FormEnums.FormSectionType.WIZARDTAB,
      icon: IconDefinitionConstants.WInfo,
      navKey: TimeReportingProjectConstants.NavigationKey.ProjectInformation,
      innerFields: genericInfoFields,
    },
  ];

  const formFieldsStep2: GenericFormSection<TimeReportingProjectFormTypes.Create>[] = [
    {
      label: TranslationKeys.TimeReportingProject.InvoicingSettings,
      type: FormEnums.FormSectionType.WIZARDTAB,
      icon: IconDefinitionConstants.WPaperPlane,
      navKey: TimeReportingProjectConstants.NavigationKey.InvoicingSettings,
      innerFields: invoicingFields,
    },
  ];

  const formFieldsStep3: GenericFormSection<TimeReportingProjectFormTypes.Create>[] = [
    {
      label: TranslationKeys.TimeReportingProject.Members,
      type: FormEnums.FormSectionType.WIZARDTAB,
      icon: IconDefinitionConstants.WUsers,
      navKey: TimeReportingProjectConstants.NavigationKey.Members,
      innerFields: membersFields,
    },
  ];

  const formFieldsStep4: GenericFormSection<TimeReportingProjectFormTypes.Create>[] = [
    {
      label: TranslationKeys.TimeReportingProject.ProjectCategories,
      type: FormEnums.FormSectionType.WIZARDTAB,
      icon: IconDefinitionConstants.WHashtag,
      navKey: TimeReportingProjectConstants.NavigationKey.ProjectCategories,
      innerFields: projectCategoryFields,
    },
  ];

  return (
    <GenericForm
      formRef={ref}
      {...props}
      fields={formFieldsStep1.concat(formFieldsStep2).concat(formFieldsStep3).concat(formFieldsStep4)}
      inline
      hideSuccess
      wizardConfig={{
        showStepIcons: !props.isCreate,
        isSettingsWizard: true,
      }}
    />
  );
};

export default forwardRef(TimeReportingProjectForm);
